<template>
  <g class="fill-none" :style="[strokeStyle]" stroke-linecap="round" stroke-linejoin="round">
    <path d="M15.322 2.549a8.989 8.989 0 012.251 16.5v4.2" />
    <path d="M13.072 7.5a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5z" />
    <path
      d="M10.822 8.25V1.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75v6.75M4.073 15.761l-.936-.234a1.5 1.5 0 01-.884-2.287l1.82-2.729v-.75c0-3.542 2.868-6.511 6.749-7.3M8.573 23.25v-2.239l-1.007.167c-.414.07-.838.052-1.244-.053M13.072 11.25a7.5 7.5 0 01-7.5 7.5h-1.5"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconHeadphones",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>